import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import HeaderBackendComponent from "../../components/Header/headerBackendMobile";
import OrdersIndex from "../../components/orders";
import BaekVoitureOrderComponent from "../../components/orders/BaekVoitureOrder";
import BeekerOndernemerOrderComponent from "../../components/orders/BeekerondernemerOrder";



const BaekVoitureOrderView = () => (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="Inschrijvingen" subtitle="Baek Voiture" md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    <HeaderBackendComponent />
    <BaekVoitureOrderComponent />
    
  </Container>
);

export default BaekVoitureOrderView;
